export default {
  install (Vue) {
    // 1. добавление глобального метода или свойства
    Vue.prototype.$isMobile = {
      Android () {
        return (
          typeof window !== 'undefined' &&
                    window.navigator.userAgent.match(/Android/i)
        )
      },
      BlackBerry () {
        return (
          typeof window !== 'undefined' &&
                    window.navigator.userAgent.match(/BlackBerry/i)
        )
      },
      iOS () {
        return (
          typeof window !== 'undefined' &&
                    window.navigator.userAgent.match(/iPhone|iPad|iPod/i)
        )
      },
      Opera () {
        return (
          typeof window !== 'undefined' &&
                    window.navigator.userAgent.match(/Opera Mini/i)
        )
      },
      Windows () {
        return (
          typeof window !== 'undefined' &&
                    window.navigator.userAgent.match(/IEMobile/i)
        )
      },
      any () {
        return (
          this.Android() ||
                    this.BlackBerry() ||
                    this.iOS() ||
                    this.Opera() ||
                    this.Windows()
        )
      }
    }
  }
}
